import React from 'react';
import { View, Text, StyleSheet, Image } from 'react-native';

export default function KitchenBlokkView() {
    return (
        <View style={styles.container}>
            <View style={styles.row}>
                <Image source={require('../../assets/wolt.png')} style={styles.icon} />
                <Text style={styles.label}>
                    Platform: <Text style={styles.bold}>Wolt</Text>
                </Text>
            </View>
            <Text style={styles.label}>Rendelés ideje: 12:30</Text>

            <Text style={styles.separator}>-----------------------------------------------</Text>

            <Text style={styles.itemLine}>Pizza Margherita                                1 adag</Text>
            <Text style={styles.itemLine}>Coca Cola 0.5l                                  2 adag</Text>
            <Text style={styles.itemLine}>Pizza Bolognai (Extra HOT!)           1 adag</Text>
            <Text style={styles.subItem}>+ Salami</Text>
            <Text style={styles.subItem}>+ Ham</Text>

            <Text style={styles.separator}>-----------------------------------------------</Text>

            <View style={styles.footer}>
                <Text>Felszolgáló: Lajos</Text>
                <Text>2025-05-25 12:30</Text>
            </View>
        </View>
    );
}

const styles = StyleSheet.create({
    container: {
        backgroundColor: '#fff',
        padding: 16,
        width: 576, // Matches 80mm printers (203 dpi)
    },
    row: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    icon: {
        width: 24,
        height: 24,
        marginRight: 8,
    },
    label: {
        fontSize: 20,
    },
    bold: {
        fontWeight: 'bold',
    },
    separator: {
        marginVertical: 8,
        fontSize: 18,
    },
    itemLine: {
        fontSize: 20,
    },
    subItem: {
        fontSize: 18,
        marginLeft: 20,
    },
    footer: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginTop: 8,
        fontSize: 18,
    },
});
